import type { ThemeMode } from '@/hooks/useLightMode'

import { Stack, Text } from '@hivewatch/dark'

import { settingsColorToken } from '../utils/settingsColorToken'

interface SettingsReadOnlyFieldIProps {
  colorScheme: ThemeMode
  dataTestId?: string
  label: string
  value: string
}

/**
 * A settings value the user can never edit, rendered as a label above static
 * text rather than a disabled input — input chrome on a permanently read-only
 * value only suggests otherwise (ENG-33661).
 *
 * `label` + `text.primary` mirrors the dark package's own `fieldLabelStyles`,
 * so these read identically to the editable fields they sit beside. A plain
 * `Text` rather than dark's `FieldLabel`: that renders a `<label>`, and a
 * `<label>` with no control to point at is worse for screen readers than
 * plain text.
 */
export const SettingsReadOnlyField = ({
  colorScheme,
  dataTestId,
  label,
  value,
}: SettingsReadOnlyFieldIProps) => (
  <Stack gap='4px'>
    <Text
      color={settingsColorToken(colorScheme, 'text.primary')}
      textStyle='label'
    >
      {label}
    </Text>
    <Text
      color={settingsColorToken(colorScheme, 'text.secondary')}
      data-testid={dataTestId}
      textStyle='body'
    >
      {value}
    </Text>
  </Stack>
)
